module.exports = __webpack_public_path__ + "static/img/xk3.f0d2603.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xk3.png
// module id = eK6l
// module chunks = 0